import { h } from '../utils/dom';
import { sanitize } from '../utils/sanitize';
import { getSendIcon } from './mark';

export class Composer {
  el: HTMLDivElement;
  private textarea: HTMLTextAreaElement;
  private sendBtn: HTMLButtonElement;
  private onSend: (text: string) => void;

  constructor(onSend: (text: string) => void) {
    this.onSend = onSend;
    this.el = h('div', { class: 'att-composer', role: 'form', 'aria-label': 'Escrever mensagem' }) as HTMLDivElement;

    this.textarea = h('textarea', {
      class: 'att-composer-input',
      placeholder: 'Escreva uma mensagem...',
      rows: '1',
      'aria-label': 'Mensagem',
      maxlength: '4096',
    }) as HTMLTextAreaElement;

    this.sendBtn = h('button', {
      class: 'att-composer-send',
      type: 'button',
      'aria-label': 'Enviar',
      disabled: 'true',
    }) as HTMLButtonElement;
    this.sendBtn.innerHTML = getSendIcon('white', 18);

    this.textarea.addEventListener('input', () => {
      this.autoResize();
      this.updateSendState();
    });

    this.textarea.addEventListener('keydown', (e: KeyboardEvent) => {
      // isComposing: Enter confirma a sugestão do teclado/IME e não pode enviar a mensagem
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        this.submit();
      }
    });

    this.sendBtn.addEventListener('click', () => {
      this.submit();
    });

    this.el.appendChild(this.textarea);
    this.el.appendChild(this.sendBtn);
  }

  private autoResize(): void {
    this.textarea.style.height = 'auto';
    this.textarea.style.height = Math.min(this.textarea.scrollHeight, 120) + 'px';
  }

  private updateSendState(): void {
    const empty = this.textarea.value.trim().length === 0;
    if (empty) {
      this.sendBtn.setAttribute('disabled', 'true');
    } else {
      this.sendBtn.removeAttribute('disabled');
    }
  }

  private submit(): void {
    const text = sanitize(this.textarea.value.trim());
    if (!text) return;
    this.textarea.value = '';
    this.textarea.style.height = '';
    this.updateSendState();
    this.onSend(text);
  }

  focus(): void {
    // Don't focus on mobile (triggers keyboard)
    if (window.innerWidth > 520) {
      this.textarea.focus();
    }
  }

  setDisabled(disabled: boolean): void {
    this.textarea.disabled = disabled;
    if (disabled) {
      this.sendBtn.setAttribute('disabled', 'true');
    } else {
      this.updateSendState();
    }
  }
}
